import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';

const navigations = [withModules, courseWrapper];

export default navigations;
